export default __webpack_public_path__ + "static/media/董瑞豹.856f6e14.png";